import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { theme } from "../../theme"; // 🟢 KHÔI PHỤC THEME GỐC ĐỂ BẢO VỆ NAVBAR
import { 
    Box, Button, Container, Table, TableBody, TableCell, TableHead, TableRow, 
    Grid, Card, CardContent, Typography, Stack, Chip, Divider, CircularProgress, TableContainer
} from "@mui/material";
import { AccessTime, CasinoOutlined, AnalyticsOutlined, RefreshOutlined, TouchAppOutlined, GroupOutlined } from "@mui/icons-material";
import axios from "axios";
import { useEffect, useState } from "react";
import swal from "sweetalert";
import { t } from "i18next";
import { GetNameChoose } from "../../funcUtils";

// ==========================================
// THEME: PLUS JAKARTA SANS (PREMIUM UI)
// ==========================================
const metronicTheme = createTheme({
    palette: {
        background: { default: "#F5F8FA", paper: "#FFFFFF" }, 
        text: { primary: "#181C32", secondary: "#7E8299" }, 
        primary: { main: "#1B84FF", light: "#F1FAFF" },
        success: { main: "#50CD89", light: "#E8FFF3" },
        danger: { main: "#F1416C", light: "#FFF5F8" },
        warning: { main: "#FFC700", light: "#FFF8DD" },
        info: { main: "#7239EA", light: "#F8F5FF" },
        dark: { main: "#181C32", light: "#3F4254" }
    },
    typography: { fontFamily: "'Plus Jakarta Sans', sans-serif" },
    components: {
        MuiCard: {
            styleOverrides: {
                root: { borderRadius: "12px", boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.03)", border: "1px solid #E4E6EF" }
            }
        },
        MuiTableCell: {
            styleOverrides: {
                root: { borderBottom: "1px solid #EFF2F5 !important", padding: "14px 12px", color: "#3F4254", fontSize: "0.85rem", fontFamily: "'Plus Jakarta Sans', sans-serif !important" }
            }
        },
        MuiButton: {
            styleOverrides: { root: { fontFamily: "'Plus Jakarta Sans', sans-serif" } }
        }
    }
});

axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("user");
        if (token) config.headers["Authorization"] = `Bearer ${token}`;
        return config;
    },
    (error) => Promise.reject(error)
);

function SetXD() {
    const [list30, setList30] = useState();
    const [bet, setBet] = useState(null);
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    
    // Đồng hồ đếm ngược 60s
    const [second, setSecond] = useState(60);
    const [minute, setMinute] = useState(0);
    
    const [start, setStart] = useState(false);
    const [dulieunhap, setDulieunhap] = useState(new Date());
    const [update, setUpdate] = useState(0);
    const [current, setCurrent] = useState(null);
    const [total, setTotal] = useState(null);
    const [kq, setKQ] = useState("");

    // STATE CHO XÓC ĐĨA: Mảng 4 phần tử (0 = Trắng, 1 = Đỏ). Mặc định là 2 Trắng 2 Đỏ (0011)
    const [coins, setCoins] = useState([0, 0, 1, 1]);

    const date = new Date();

    function formatDate(m) {
        if (!m) return "";
        const d = new Date(m);
        return `${("0" + d.getHours()).slice(-2)}:${("0" + d.getMinutes()).slice(-2)} ${("0" + d.getDate()).slice(-2)}/${("0" + (d.getMonth() + 1)).slice(-2)}`;
    }

    // Tự động dịch mã cược thành tên cho dễ nhìn
    const getBetLabel = (stateStr) => {
        if (!stateStr) return { text: "", color: "default", bg: "transparent" };
        
        const map = { 
            "5": { text: "CHẴN", color: "#50CD89", bg: "#E8FFF3" },
            "6": { text: "LẺ", color: "#7239EA", bg: "#F8F5FF" },
            "1": { text: "4 ĐỎ", color: "#F1416C", bg: "#FFF5F8" },
            "2": { text: "4 TRẮNG", color: "#7E8299", bg: "#F5F8FA" },
            "3": { text: "3 ĐỎ 1 TRẮNG", color: "#FFC700", bg: "#FFF8DD" },
            "4": { text: "3 TRẮNG 1 ĐỎ", color: "#1B84FF", bg: "#F1FAFF" }
        };

        return map[stateStr] || { text: stateStr, color: "#181C32", bg: "#F5F8FA" };
    };

    const reloadHistorySilently = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/xd60s/getadmin`).then((res) => {
            if (res.data?.data?.length > 0) setBet(res.data.data[0]);
        }).catch(() => {});
        axios.get(`${process.env.REACT_APP_API_URL}/xd60s/list30bet`).then((res) => setList30(res.data.data)).catch(() => setList30(null));
        axios.get(`${process.env.REACT_APP_API_URL}/xd60s/getcurrent`).then((res) => setCurrent(res.data.data)).catch(() => {});
    };

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/xd60s/getadmin`).then((res) => {
            if(res.data?.data?.[0]) {
                setBet(res.data.data[0]);
                setDulieunhap(new Date(res.data.data[0].createdAt));
                setStart(true);
            }
        }).catch(() => {});
        axios.get(`${process.env.REACT_APP_API_URL}/xd60s/getallbet`, {}).then((res) => setTotal(res.data.data)).catch(() => setTotal(null));
        reloadHistorySilently();
    }, []);

    // FETCH KIỂM TRA ĐỔI PHIÊN MỖI 0.5s (Với thời gian 60s)
    useEffect(() => {
        const timer = setInterval(() => {
            if (Math.floor(60 - (new Date() - dulieunhap) / 1000) < 0) {
                axios.get(`${process.env.REACT_APP_API_URL}/xd60s/getadmin`).then((res) => {
                    if(res.data?.data?.[0]) {
                        setBet(res.data.data[0]);
                        setDulieunhap(new Date(res.data.data[0].createdAt));
                    }
                }).catch(() => {});
                axios.get(`${process.env.REACT_APP_API_URL}/xd60s/getallbet`, {}).then((res) => setTotal(res.data.data)).catch(() => setTotal(null));
                reloadHistorySilently();
            }
        }, 500);
        return () => clearInterval(timer);
    }, [dulieunhap]);

    // ĐỒNG BỘ THỜI GIAN (CHUẨN HÓA 60 GIÂY)
    useEffect(() => {
        let curTime_second = Math.floor(60 - (date - dulieunhap) / 1000);
        let myTimeout;

        if (curTime_second <= 60 && curTime_second >= 0) {
            setSecond(curTime_second);
            setMinute(0); 
            setStart(true);
            return () => clearTimeout(myTimeout);
        } else {
            myTimeout = setTimeout(() => setUpdate(update + 1), 500);
        }
    }, [update, dulieunhap]);

    // CHẠY ĐỒNG HỒ ĐẾM NGƯỢC
    useEffect(() => {
        let curTime_second = Math.floor(60 - (date - dulieunhap) / 1000);
        let myTimeout = 0;
        
        if (start) {
            setSecond(curTime_second);
            setMinute(0); 
            
            if (curTime_second > 60 || curTime_second <= 0) {
                setStart(false);
                setMinute(0);
                setSecond(0);
                return () => clearTimeout(myTimeout);
            }
            myTimeout = setTimeout(() => {
                setSecond(second - 1);
                axios.get(`${process.env.REACT_APP_API_URL}/xd60s/getcurrent`).then((res) => setCurrent(res.data.data)).catch(() => setCurrent(null));
            }, 1000);
        }
        return () => clearTimeout(myTimeout);
    }, [second, start, dulieunhap]);

    // XỬ LÝ NÚT BẤM HOẶC LƯU CỦA GAME THẬT
    const handleQuickSubmit = (resultString) => {
        if (!bet) return;
        const cleanResult = resultString.replace(/[^01]/g, '');
        if (cleanResult.length !== 4) return swal("Lỗi", "Kết quả phải đúng 4 vị (0 hoặc 1).", "warning");

        const formData = { id_bet: bet._id, result: cleanResult };
        axios.post(`${process.env.REACT_APP_API_URL}/xd60s/update`, formData)
            .then((res) => {
                swal(t('success'), `Đã set kết quả [ ${cleanResult} ] thành công!`, "success");
                reloadHistorySilently();
            })
            .catch((res) => swal(t('error'), "Có lỗi xảy ra!", "error"));
    };

    // Hàm cập nhật kết quả hiển thị cho Bot AI
    const handleAISubmit = (id_bet, aiResultString) => {
        const formData = { id_bet: id_bet, ai_result: aiResultString };
        axios.post(`${process.env.REACT_APP_API_URL}/xd60s/update`, formData)
            .then(() => {
                swal(t('success'), `Đã thay đổi kết quả AI thành công!`, "success");
                reloadHistorySilently();
            })
            .catch(() => swal(t('error'), "Có lỗi xảy ra!", "error"));
    };

    const handleManualSubmit = (e) => {
        e.preventDefault();
        if (!bet || !kq) return;
        const cleanKq = kq.replace(/[^01]/g, '');
        if (cleanKq.length !== 4) return swal("Lỗi", "Vui lòng nhập đúng 4 vị (Ví dụ: 0011)", "warning");
        handleQuickSubmit(cleanKq);
        setKQ(""); 
    };

    function thongke(num) {
        if (!current) return 0;
        let totalMoney = 0;
        current.forEach((item) => {
            const states = item.state.split(" ").map(Number);
            if (states.includes(num)) totalMoney += item.money / states.length;
        });
        return Number(totalMoney).toLocaleString("vi-VN");
    }

    // LOGIC CHO GIAO DIỆN ĐỒNG XU
    const toggleCoin = (index) => {
        const newCoins = [...coins];
        newCoins[index] = newCoins[index] === 0 ? 1 : 0; 
        setCoins(newCoins);
    };

    const handleSaveCoins = () => {
        handleQuickSubmit(coins.join(""));
    };

    // PHÂN TÍCH KẾT QUẢ ĐỒNG XU (Tính Chẵn/Lẻ)
    const redCount = coins.filter(c => c === 1).length;
    let coinLabel = "";
    let coinType = ""; // Chẵn hay Lẻ
    let coinColor = "";

    if (redCount === 0) { coinLabel = "4 Trắng"; coinType = "CHẴN"; coinColor = "#A1A5B7"; } // Xám
    else if (redCount === 1) { coinLabel = "3 Trắng 1 Đỏ"; coinType = "LẺ"; coinColor = "#1B84FF"; } // Xanh dương
    else if (redCount === 2) { coinLabel = "2 Trắng 2 Đỏ"; coinType = "CHẴN"; coinColor = "#50CD89"; } // Xanh lá
    else if (redCount === 3) { coinLabel = "3 Đỏ 1 Trắng"; coinType = "LẺ"; coinColor = "#FFC700"; } // Vàng
    else if (redCount === 4) { coinLabel = "4 Đỏ"; coinType = "CHẴN"; coinColor = "#F1416C"; } // Đỏ

    const isDangerTime = second <= 10;

    return (
        // 🟢 BỌC THEME GỐC Ở ĐÂY ĐỂ BẢO VỆ NAVBAR
        <ThemeProvider theme={theme}>
            <DashboardLayout>
                
                {/* 🟢 BỌC THEME MỚI Ở TRONG ĐỂ LÀM ĐẸP GIAO DIỆN CHÍNH */}
                <ThemeProvider theme={metronicTheme}>
                    <style>{`
                        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
                        .safe-xd-zone * { text-align: left !important; box-sizing: border-box; font-family: 'Plus Jakarta Sans', sans-serif !important; }
                        .safe-xd-zone input { text-align: center !important; }
                    `}</style>

                    <Box className="safe-xd-zone" component="main" sx={{ flexGrow: 1, py: 4, backgroundColor: 'background.default', minHeight: 'calc(100vh - 70px)' }}>
                        <Container maxWidth="xl">
                            
                            {/* HEADER */}
                            <Box mb={4} display="flex" justifyContent="space-between" alignItems="center">
                                <Box>
                                    <Typography variant="h4" fontWeight="800" color="#181C32">XÓC ĐĨA 60S</Typography>
                                    <Typography variant="body2" color="text.secondary">Giao diện điều khiển và mô phỏng Đồng xu Live</Typography>
                                </Box>
                                <Button variant="outlined" startIcon={<RefreshOutlined />} onClick={() => window.location.reload()} sx={{ borderRadius: '8px', fontWeight: 700, textTransform: 'none' }}>
                                    Làm mới
                                </Button>
                            </Box>

                            <Grid container spacing={3} mb={4}>
                                {/* ========================================= */}
                                {/* PANEL TRÁI: MÀN HÌNH LIVE & THỐNG KÊ CƯỢC */}
                                {/* ========================================= */}
                                <Grid item xs={12} lg={5}>
                                    <Card sx={{ height: '100%', backgroundColor: '#FFFFFF' }}>
                                        <CardContent sx={{ p: 4, display: 'flex', flexDirection: 'column', height: '100%' }}>
                                            
                                            <Box display="flex" justifyContent="space-between" alignItems="center" mb={4}>
                                                <Box>
                                                    <Typography variant="caption" fontWeight="800" color="#A1A5B7" sx={{ textTransform: 'uppercase', letterSpacing: '1px' }}>Kỳ quay hiện tại</Typography>
                                                    {bet ? (
                                                        <Typography variant="h5" fontWeight="800" color="#1B84FF">#{bet.id_bet}</Typography>
                                                    ) : (
                                                        <Typography variant="h6" fontWeight="700" color="text.secondary">{t("waiting")}...</Typography>
                                                    )}
                                                </Box>
                                                <Chip 
                                                    icon={<AccessTime sx={{ fontSize: '16px !important', color: isDangerTime ? '#FFF !important' : 'inherit' }} />} 
                                                    label={`00:${second < 10 ? '0' : ''}${second}`} 
                                                    sx={{ 
                                                        backgroundColor: isDangerTime ? '#F1416C' : '#36db15', 
                                                        color: isDangerTime ? '#FFFFFF' : '#ffffff', 
                                                        fontWeight: 800, fontSize: '1.5rem', py: 3, px: 1, borderRadius: '12px',
                                                        animation: isDangerTime ? 'pulse 1s infinite' : 'none',
                                                        '@keyframes pulse': { '0%': { opacity: 1 }, '50%': { opacity: 0.5 }, '100%': { opacity: 1 } }
                                                    }} 
                                                />
                                            </Box>

                                            <Divider sx={{ mb: 3 }} />

                                            <Typography variant="subtitle1" fontWeight="800" color="#181C32" mb={2} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <AnalyticsOutlined color="primary" /> Tiền cược các cửa
                                            </Typography>

                                            <Grid container spacing={2}>
                                                <Grid item xs={6}>
                                                    <Box sx={{ p: 2, borderRadius: '12px', backgroundColor: '#E8FFF3', border: '1px solid #86EFAC' }}>
                                                        <Typography variant="caption" fontWeight="800" color="#50CD89">TỔNG CHẴN</Typography>
                                                        <Typography variant="h6" fontWeight="800" color="#181C32">{thongke(5)} <span style={{fontSize: '12px', color: '#A1A5B7'}}>đ</span></Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Box sx={{ p: 2, borderRadius: '12px', backgroundColor: '#F8F5FF', border: '1px solid #D8B4FE' }}>
                                                        <Typography variant="caption" fontWeight="800" color="#7239EA">TỔNG LẺ</Typography>
                                                        <Typography variant="h6" fontWeight="800" color="#181C32">{thongke(6)} <span style={{fontSize: '12px', color: '#A1A5B7'}}>đ</span></Typography>
                                                    </Box>
                                                </Grid>

                                                <Grid item xs={6} sm={3}>
                                                    <Box sx={{ p: 1.5, borderRadius: '12px', backgroundColor: '#FFF5F8', textAlign: 'center !important' }}>
                                                        <Typography variant="caption" fontWeight="800" color="#F1416C" sx={{textAlign: 'center !important', display:'block'}}>4 ĐỎ</Typography>
                                                        <Typography variant="subtitle2" fontWeight="800" color="#181C32" sx={{textAlign: 'center !important'}}>{thongke(1)}</Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={6} sm={3}>
                                                    <Box sx={{ p: 1.5, borderRadius: '12px', backgroundColor: '#F5F8FA', textAlign: 'center !important' }}>
                                                        <Typography variant="caption" fontWeight="800" color="#7E8299" sx={{textAlign: 'center !important', display:'block'}}>4 TRẮNG</Typography>
                                                        <Typography variant="subtitle2" fontWeight="800" color="#181C32" sx={{textAlign: 'center !important'}}>{thongke(2)}</Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={6} sm={3}>
                                                    <Box sx={{ p: 1.5, borderRadius: '12px', backgroundColor: '#FFF8DD', textAlign: 'center !important' }}>
                                                        <Typography variant="caption" fontWeight="800" color="#FFC700" sx={{textAlign: 'center !important', display:'block'}}>3Đ - 1T</Typography>
                                                        <Typography variant="subtitle2" fontWeight="800" color="#181C32" sx={{textAlign: 'center !important'}}>{thongke(3)}</Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={6} sm={3}>
                                                    <Box sx={{ p: 1.5, borderRadius: '12px', backgroundColor: '#F1FAFF', textAlign: 'center !important' }}>
                                                        <Typography variant="caption" fontWeight="800" color="#1B84FF" sx={{textAlign: 'center !important', display:'block'}}>3T - 1Đ</Typography>
                                                        <Typography variant="subtitle2" fontWeight="800" color="#181C32" sx={{textAlign: 'center !important'}}>{thongke(4)}</Typography>
                                                    </Box>
                                                </Grid>
                                            </Grid>

                                        </CardContent>
                                    </Card>
                                </Grid>

                                {/* ========================================= */}
                                {/* PANEL PHẢI: BÀN ĐIỀU KHIỂN & ĐỒNG XU      */}
                                {/* ========================================= */}
                                <Grid item xs={12} lg={7}>
                                    <Card sx={{ height: '100%', backgroundColor: '#FFFFFF' }}>
                                        <CardContent sx={{ p: 4 }}>
                                            <Typography variant="subtitle1" fontWeight="800" color="#181C32" mb={3} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <CasinoOutlined color="warning" /> Lật Đồng Xu Trực Tiếp
                                            </Typography>

                                            {/* BÀN CHƠI: HIỂN THỊ ĐỒNG XU */}
                                            <Box sx={{ p: 4, backgroundColor: '#1E1E2D', borderRadius: '16px', mb: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'relative', overflow: 'hidden' }}>
                                                
                                                <Typography variant="caption" color="#A1A5B7" fontWeight="700" mb={3} sx={{ textAlign: 'center !important', letterSpacing: '1.5px', zIndex: 1 }}>
                                                    <TouchAppOutlined sx={{ fontSize: '14px', verticalAlign: 'middle', mr: 0.5 }}/> CLICK VÀO ĐỒNG XU ĐỂ ĐỔI MÀU
                                                </Typography>
                                                
                                                <Stack direction="row" spacing={3} mb={4} sx={{ zIndex: 1 }}>
                                                    {coins.map((val, idx) => (
                                                        <Box 
                                                            key={idx} 
                                                            onClick={() => toggleCoin(idx)}
                                                            sx={{ 
                                                                width: 70, height: 70, borderRadius: '50%', cursor: 'pointer',
                                                                backgroundColor: val === 1 ? '#F1416C' : '#F5F8FA', // Đỏ hoặc Trắng (Xám nhạt)
                                                                border: val === 1 ? '4px solid #D92B54' : '4px solid #E4E6EF',
                                                                boxShadow: val === 1 
                                                                    ? 'inset 0 6px 10px rgba(255,255,255,0.3), 0 8px 20px rgba(241,65,108,0.5)' 
                                                                    : 'inset 0 6px 10px rgba(255,255,255,0.8), 0 8px 20px rgba(0,0,0,0.15)',
                                                                transition: 'all 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                                                                '&:hover': { transform: 'scale(1.1) translateY(-5px)' },
                                                                '&:active': { transform: 'scale(0.95)' }
                                                            }} 
                                                        />
                                                    ))}
                                                </Stack>
                                                
                                                <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', zIndex: 1 }}>
                                                    <Chip label={`Kết quả: ${coins.join("")}`} sx={{ backgroundColor: 'rgba(255,255,255,0.1)', color: '#FFF', fontWeight: 800, fontSize: '13px' }} />
                                                    <Chip label={coinLabel} sx={{ backgroundColor: 'rgba(255,255,255,0.1)', color: '#FFF', fontWeight: 800, fontSize: '13px' }} />
                                                    <Chip label={coinType} sx={{ backgroundColor: coinColor, color: '#FFF', fontWeight: 900, fontSize: '14px', px: 1 }} />
                                                </Box>
                                            </Box>

                                            {/* NÚT LƯU KẾT QUẢ THEO ĐỒNG XU */}
                                            <Box textAlign="center" mb={4}>
                                                <Button variant="contained" onClick={handleSaveCoins} sx={{ backgroundColor: '#181C32', color: '#FFF', fontWeight: 800, borderRadius: '8px', px: 6, py: 1.5, fontSize: '1rem', '&:hover': { backgroundColor: '#3F4254' } }}>
                                                    LƯU ĐĨA NÀY ({coinType})
                                                </Button>
                                            </Box>

                                            <Divider sx={{ mb: 3 }}>
                                                <Chip label="Cài đặt nhanh" size="small" sx={{ color: '#A1A5B7', fontWeight: 700 }} />
                                            </Divider>

                                            {/* 6 NÚT CÀI NHANH MỚI & KHUNG NHẬP TAY */}
                                            <Box display="flex" gap={2} flexWrap="wrap" justifyContent="space-between" alignItems="center">
                                                
                                                <Grid container spacing={1} sx={{ maxWidth: { xs: '100%', sm: '450px' } }}>
                                                    <Grid item xs={4}><Button fullWidth variant="contained" sx={{ bgcolor: '#50CD89', color: '#fff', fontWeight: 800, boxShadow: 'none', '&:hover':{bgcolor: '#39b572'} }} onClick={() => handleQuickSubmit("0011")}>CHẴN</Button></Grid>
                                                    <Grid item xs={4}><Button fullWidth variant="contained" sx={{ bgcolor: '#7239EA', color: '#fff', fontWeight: 800, boxShadow: 'none', '&:hover':{bgcolor: '#5d2bd1'} }} onClick={() => handleQuickSubmit("0111")}>LẺ</Button></Grid>
                                                    <Grid item xs={4}><Button fullWidth variant="contained" sx={{ bgcolor: '#F1416C', color: '#fff', fontWeight: 800, boxShadow: 'none', '&:hover':{bgcolor: '#d93a61'} }} onClick={() => handleQuickSubmit("1111")}>4 ĐỎ</Button></Grid>
                                                    
                                                    <Grid item xs={4}><Button fullWidth variant="contained" sx={{ bgcolor: '#A1A5B7', color: '#fff', fontWeight: 800, boxShadow: 'none', '&:hover':{bgcolor: '#8b8e9f'} }} onClick={() => handleQuickSubmit("0000")}>4 TRẮNG</Button></Grid>
                                                    <Grid item xs={4}><Button fullWidth variant="contained" sx={{ bgcolor: '#FFC700', color: '#fff', fontWeight: 800, boxShadow: 'none', '&:hover':{bgcolor: '#e5b300'} }} onClick={() => handleQuickSubmit("0111")}>3Đ - 1T</Button></Grid>
                                                    <Grid item xs={4}><Button fullWidth variant="contained" sx={{ bgcolor: '#1B84FF', color: '#fff', fontWeight: 800, boxShadow: 'none', '&:hover':{bgcolor: '#1771d9'} }} onClick={() => handleQuickSubmit("0001")}>3T - 1Đ</Button></Grid>
                                                </Grid>

                                            </Box>

                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>

                            {/* ========================================= */}
                            {/* BẢNG DANH SÁCH NGƯỜI CHƠI ĐANG CƯỢC       */}
                            {/* ========================================= */}
                            <Card sx={{ backgroundColor: '#FFFFFF', mb: 4 }}>
                                <Box sx={{ p: 2.5, borderBottom: '1px solid #EFF2F5', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Typography variant="h6" fontWeight="800" color="#181C32" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <GroupOutlined color="primary" /> Danh Sách Người Chơi Kỳ Này
                                    </Typography>
                                    <Chip label={`Tổng: ${current ? current.length : 0} đơn cược`} size="small" sx={{ backgroundColor: '#F1FAFF', color: '#1B84FF', fontWeight: 800 }} />
                                </Box>
                                <TableContainer sx={{ overflowX: 'auto', maxHeight: '400px' }}>
                                    <Table stickyHeader sx={{ minWidth: 1460 }}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{ color: '#A1A5B7 !important', fontWeight: '800 !important', textTransform: 'uppercase', backgroundColor: '#FFFFFF' }}>Tài Khoản</TableCell>
                                                <TableCell sx={{ color: '#A1A5B7 !important', fontWeight: '800 !important', textTransform: 'uppercase', backgroundColor: '#FFFFFF' }}>Cửa Cược</TableCell>
                                                <TableCell sx={{ color: '#A1A5B7 !important', fontWeight: '800 !important', textTransform: 'uppercase', backgroundColor: '#FFFFFF' }}>Số Tiền</TableCell>
                                                <TableCell sx={{ color: '#A1A5B7 !important', fontWeight: '800 !important', textTransform: 'uppercase', textAlign: 'right !important', backgroundColor: '#FFFFFF' }}>Thời Gian</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {current && current.length > 0 ? current.map((item, idx) => {
                                                const labelData = getBetLabel(item.state);
                                                return (
                                                    <TableRow key={idx} hover>
                                                        <TableCell>
                                                            <Typography variant="body2" fontWeight="800" color="#2563EB">{item?.user?.username || 'Ẩn danh'}</Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Chip 
                                                                label={labelData.text} 
                                                                size="small" 
                                                                sx={{ 
                                                                    fontWeight: 800, borderRadius: '6px', px: 1,
                                                                    backgroundColor: labelData.bg, 
                                                                    color: labelData.color 
                                                                }} 
                                                            />
                                                        </TableCell>
                                                        <TableCell>
                                                            <Typography variant="body2" fontWeight="800" color="#16A34A">
                                                                {Number(item.money).toLocaleString("vi-VN")} đ
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell sx={{ textAlign: 'right !important', color: "text.secondary", fontSize: "0.8rem", fontWeight: "600" }}>
                                                            {formatDate(new Date(item.createdAt))}
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            }) : (
                                                <TableRow>
                                                    <TableCell colSpan={4} align="center" sx={{ py: 6, color: '#A1A5B7', fontWeight: 600 }}>
                                                        Chưa có người chơi nào cược trong kỳ này
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Card>

                            {/* ========================================= */}
                            {/* BẢNG LỊCH SỬ KẾT QUẢ VÀ SỬA AI RESULT     */}
                            {/* ========================================= */}
                            <Card sx={{ backgroundColor: '#FFFFFF' }}>
                                <Box sx={{ p: 2.5, borderBottom: '1px solid #EFF2F5' }}>
                                    <Typography variant="h6" fontWeight="800" color="#181C32">Phiên Tiếp Theo</Typography>
                                </Box>
                                <Box sx={{ overflowX: 'auto' }}>
                                    <Table sx={{ minWidth: 1465 }}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{ color: '#A1A5B7 !important', fontWeight: '800 !important', textTransform: 'uppercase' }}>Kỳ quay</TableCell>
                                                <TableCell sx={{ color: '#A1A5B7 !important', fontWeight: '800 !important', textTransform: 'uppercase' }}>Kết quả Thật</TableCell>
                                                <TableCell sx={{ color: '#A1A5B7 !important', fontWeight: '800 !important', textTransform: 'uppercase', backgroundColor: '#F8F9FA' }}>Kết quả Bot AI hiển thị</TableCell>
                                                <TableCell sx={{ color: '#A1A5B7 !important', fontWeight: '800 !important', textTransform: 'uppercase', textAlign: 'right !important' }}>Thời gian</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {list30 ? list30
                                                .filter((item) => !bet || !bet.id_bet ? true : Number(item.id_bet) >= Number(bet.id_bet))
                                                .sort((a, b) => Number(a.id_bet) - Number(b.id_bet))
                                                .map((item, idx) => {
                                                    const isCurrent = item.id_bet === bet?.id_bet;
                                                    if (!isCurrent && !item.result) return null;
                                                    
                                                    return (
                                                        <TableRow key={item._id || idx} sx={{ backgroundColor: isCurrent ? '#FFF8DD' : 'inherit', transition: 'background-color 0.3s' }}>
                                                            
                                                            {/* CỘT 1: ID PHIÊN */}
                                                            <TableCell>
                                                                <Typography variant="body2" fontWeight={isCurrent ? 800 : 700} color={isCurrent ? '#FFC700' : '#181C32'}>
                                                                    #{item?.id_bet} {isCurrent && "(Đang chạy)"}
                                                                </Typography>
                                                            </TableCell>
                                                            
                                                            {/* CỘT 2: SỬA KẾT QUẢ THẬT (ẢNH HƯỞNG TIỀN) */}
                                                            <TableCell>
                                                                <form style={{ display: 'flex', gap: '8px', alignItems: 'center' }} onSubmit={(e) => {
                                                                    e.preventDefault();
                                                                    const rawVal = e.target.result.value;
                                                                    if (!rawVal) return;
                                                                    const digits = String(rawVal).replace(/[^01]/g, '');
                                                                    if (digits.length !== 4) return swal("Lỗi", "Vui lòng nhập đúng 4 vị (0 hoặc 1)", "warning");
                                                                    axios.post(`${process.env.REACT_APP_API_URL}/xd60s/update`, { id_bet: item._id, result: digits })
                                                                        .then(() => { swal(t('success'), `Sửa KQ thật phiên ${item.id_bet} thành công`, "success"); reloadHistorySilently(); })
                                                                        .catch(() => swal(t('error'), "Lỗi kết nối", "error"));
                                                                }}>
                                                                    <Typography variant="body2" fontWeight="800" color="#3F4254" sx={{ width: '40px', letterSpacing: '2px' }}>
                                                                        {item.result || "----"}
                                                                    </Typography>
                                                                    <input 
                                                                        name="result" type="text" placeholder="Nhập 4 số..." maxLength="4"
                                                                        style={{ width: '90px', padding: '6px 10px', border: '1px solid #E4E6EF', borderRadius: '6px', outline: 'none', fontWeight: 700, textAlign: 'center' }} 
                                                                    />
                                                                    <Button type="submit" variant="contained" size="small" sx={{ backgroundColor: '#F1FAFF', color: '#1B84FF', boxShadow: 'none', fontWeight: 800, '&:hover': {backgroundColor: '#1B84FF', color: '#FFF'} }}>
                                                                        SỬA THẬT
                                                                    </Button>
                                                                </form>
                                                            </TableCell>

                                                            {/* CỘT 3: SỬA KẾT QUẢ BOT AI (CHỈ ĐỂ LÙA GÀ KHÔNG TRỪ TIỀN) */}
                                                            <TableCell sx={{ backgroundColor: isCurrent ? 'rgba(255,255,255,0.4)' : '#F8F9FA' }}>
                                                                <form style={{ display: 'flex', gap: '8px', alignItems: 'center' }} onSubmit={(e) => {
                                                                    e.preventDefault();
                                                                    const rawVal = e.target.ai_result.value;
                                                                    if (!rawVal) return;
                                                                    const digits = String(rawVal).replace(/[^01]/g, '');
                                                                    if (digits.length !== 4) return swal("Lỗi", "Vui lòng nhập đúng 4 vị (0 hoặc 1)", "warning");
                                                                    handleAISubmit(item._id, digits);
                                                                }}>
                                                                    <Typography variant="body2" fontWeight="900" color="#009EF7" sx={{ width: '40px', letterSpacing: '2px' }}>
                                                                        {item.ai_result || "----"}
                                                                    </Typography>
                                                                    <input 
                                                                        name="ai_result" type="text" placeholder="Nhập 4 số..." maxLength="4"
                                                                        style={{ width: '90px', padding: '6px 10px', border: '1px solid #B5E4CA', borderRadius: '6px', outline: 'none', fontWeight: 700, textAlign: 'center', backgroundColor: '#E8FFF3', color: '#009EF7' }} 
                                                                    />
                                                                    <Button type="submit" variant="contained" size="small" sx={{ backgroundColor: '#009EF7', color: '#FFF', boxShadow: 'none', fontWeight: 800, '&:hover': {backgroundColor: '#0075FF', color: '#FFF'} }}>
                                                                        SỬA BOT
                                                                    </Button>
                                                                </form>
                                                            </TableCell>
                                                            
                                                            {/* CỘT 4: THỜI GIAN */}
                                                            <TableCell sx={{ textAlign: 'right !important' }}>
                                                                <Typography variant="caption" color="text.secondary" fontWeight="600">
                                                                    {formatDate(new Date(item.createdAt))}
                                                                </Typography>
                                                            </TableCell>
                                                        </TableRow>
                                                    );
                                                })
                                            : null}
                                        </TableBody>
                                    </Table>
                                </Box>
                            </Card>

                        </Container>
                    </Box>
                </ThemeProvider>
            </DashboardLayout>
        </ThemeProvider>
    );
}

export default SetXD;